/* istanbul ignore file */
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { licenseSelector } from 'state/selectors/license';
import { organizationSelector } from 'state/selectors/organization';

import { getColor } from 'common/constants/_colors';
import { TRACKING } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { premiumRequest } from 'common/services/general.service';
import * as TrackingService from 'common/services/tracking.service';
import { navigateBookDemoClick } from 'common/utils/utils';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import get from 'lodash/get';
import {
  LICENSE_TYPE_CONFIG,
  LICENSE_TYPE_KEYS
} from './Contributor/services/contributor.service';
import { getLicenseBarButton, getLicenseBarText } from './LicenseBar.utils';

const TopBar = styled(Flex)`
  background: ${getColor('indigo')};
  border-radius: 4px;
  padding: 2rem;
  margin-bottom: 2rem;
`;

const LicenseBar = () => {
  const license = useSelector(licenseSelector);
  const account = useSelector(myAccountSelector);
  const organization = useSelector(organizationSelector);
  const licenseType = get(license, 'licenseType');

  const openPremiumRequest = async () => {
    await premiumRequest();

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.PREMIUM,
      name: account.name,
      email: account.email,
      org: organization.name,
      org_id: organization.id
    });

    navigateBookDemoClick();
  };

  const text = getLicenseBarText(license);

  const licenseConfig = LICENSE_TYPE_CONFIG[LICENSE_TYPE_KEYS[licenseType]];
  if (!licenseConfig) return null;
  return (
    <TopBar items='center' justify='space-between'>
      <Flex items='center'>
        <Icon name='logo' color='catskillWhite' size='large' />
        <Flex items='baseline'>
          <Text color='white' size='x-large' pl={SPACES.small}>
            {licenseConfig.name}
          </Text>
          {text}
        </Flex>
      </Flex>
      {getLicenseBarButton(license, openPremiumRequest)}
    </TopBar>
  );
};

export default LicenseBar;
